import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './voucher.css'
import './hotelvoucher.css'
import { Box } from '@mui/material'
import star from '../../../../assets/images/star.svg'
import starinactive from '../../../../assets/images/starinactive.svg'
import imghotel1 from '../../../../assets/images/lemonhotel.jpg'
import { API_BASE_URL, PROFILE_IMAGE } from '../../../../utility/apiConstants'
import { getAuth } from '../../../../utility/apiConfig'
import { addZeroes, bookingStatusLabel, dayOlyDate } from '../../../../core/helper'
import logo from '../../../../assets/images/itwlogo.png'

const HotelVoucher = () => {
  const queryParams = new URLSearchParams(window.location.search)

  // url
  const ref = queryParams.get('app_ref')
  const bookingid = queryParams.get('bookingid')
  const status = queryParams.get('status')
  const arg = queryParams.get('arg')
  const url = 'voucher/hotel/' + ref + '/' + bookingid + '/' + status + '/' + arg
  const [data, setData] = useState([])
  const [Loading, setLoading] = useState(false)

  const hotelVoucherReq = () => {
    try {
      setLoading(true)
      getAuth(API_BASE_URL + url)
        .then(res => {
          if (res.status) {
            const datas = res.data.data

            let basefare = 0
            let service_charge = 0
            let gst = 0
            let admin_markup = 0
            let agent_markup = 0
            let tax = 0

            datas.booking_details[0].itinerary_details.map(i => {
              if (datas.booking_details[0].offline_status == 0) {
                if (i.RoomPrice && i.RoomPrice != 0) {
                  basefare += i.RoomPrice
                } else {
                  basefare += i.total_fare
                }
                tax += i.Tax
                service_charge = datas.booking_details[0].ServiceCharge
                gst = service_charge * 0.18
              } else {
                const attrib = JSON.parse(i.attributes)
                if (i.RoomPrice && i.RoomPrice != 0) {
                  basefare = i.RoomPrice
                } else {
                  basefare = i.total_fare
                }
                tax = i.Tax
                service_charge = attrib.service_charge
                gst = attrib.service_tax
              }

              admin_markup = i.admin_markup
              agent_markup = i.agent_markup
            })

            setData({
              ...datas,
              fare: {
                basefare: basefare,
                service_charge: service_charge,
                gst: gst,
                basefare: basefare,
                admin_markup: admin_markup,
                agent_markup: agent_markup,
                tax: tax

              }
            })
          }
          setLoading(false)
        })
        .catch(err => {
          setLoading(false)
        })
    } catch (error) {
    }
  }

  useEffect(() => {
    hotelVoucherReq()
  }, [])
  return (
        <div>
            <Container>
                {Loading ? 'Loading' : (
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Box className="VoucherBox">
                                <Row>
                                    {data.booking_details &&
                                        <table className="vouchertable">

                                            <table className="">
                                                <tr>
                                                    <td className=""><img className="hotelvoucherlogo" src={logo} alt=""></img></td>
                                                    <td className="hotelhead"><h4>E-Voucher</h4></td>
                                                </tr>
                                            </table>
                                            <table className="voucherheading">
                                                <tr>
                                                    
                                                    <td >
                                                        <p>
                                                            <span className='bookingid-txt'>BOOKING ID </span>
                                                            <div className='d-flex'>
                                                                <p className="highlited-hotel">{data.booking_details[0].booking_id}  &nbsp;</p>
                                                                <p><span className={'stscncl' + data.booking_details && data.booking_details[0].status}>{data.booking_details && bookingStatusLabel(data.booking_details[0].status)}
                                                                </span></p>
                                                            </div>
                                                        </p>

                                                        <p>
                                                            <span className='bookingid-txt'>CONFIRMATION REF </span>
                                                            <div className='d-flex'>
                                                                <p className="conf-txt-hotel">{data.booking_details[0].confirmation_reference}  &nbsp;</p>
                                                            </div>
                                                        </p>
                                                    </td>

                                                    <td className="rightheadertlt">
                                                        <p><span className='bookDetailslTxt1'>Booking Ref : </span> <span className='bookDetailslTxt2'>{data.booking_details && data.booking_details[0].app_reference}</span></p>
                                                        <p><span className='bookDetailslTxt1'>Booked On : </span> <span className='bookDetailslTxt2'>{data.booking_details && data.booking_details[0].voucher_date}</span></p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className="rowhoteldetails mt-3">
                                                <tr>
                                                    <td className="hotelimg"><div className="htlimg"><img src={JSON.parse(data.booking_details[0].attributes).HotelImage != '' ? JSON.parse(data.booking_details[0].attributes).HotelImage : imghotel1} alt=""></img></div></td>
                                                    <td className="hoteldetails">
                                                        <div className="hyltt">{data.booking_details[0].hotel_name}</div>
                                                        <div className="hylttpara">{data.booking_details[0].hotel_address}</div>
                                                        <div className="star">
                                                            <ul>
                                                                {/* {data.booking_details[0]?.star_rating } */}
                                                                <li><img src={data.booking_details[0]?.star_rating >= 1 ? star : starinactive} alt=""></img></li>
                                                                <li><img src={data.booking_details[0]?.star_rating >= 2 ? star : starinactive} alt=""></img></li>
                                                                <li><img src={data.booking_details[0]?.star_rating >= 3 ? star : starinactive} alt=""></img></li>
                                                                <li><img src={data.booking_details[0]?.star_rating >= 4 ? star : starinactive} alt=""></img></li>
                                                                <li><img src={data.booking_details[0]?.star_rating >= 5 ? star : starinactive} alt=""></img></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                            <Box className='fdetailsHeading2 mb-1 mt-4'>
                                                <h4>Hotel Details</h4>
                                            </Box>
                                            <table className="layoutdata ">
                                                <tr className="headertltdata">
                                                    <td className="tltheadimg">Check-In</td>
                                                    <td className="tlthead">Check-Out</td>
                                                    <td className="tlthead">No Of Rooms</td>
                                                    <td className="tlthead">Room Type</td>
                                                    <td className="tlthead">Adult</td>
                                                    <td className="tlthead">Children</td>
                                                </tr>
                                                {data.booking_details[0].itinerary_details.map(itinerary => (
                                                    <tr className="headertltdataenties">
                                                        <td className="imgdata">{dayOlyDate(itinerary.check_in)}</td>
                                                        <td className="imgdata">{dayOlyDate(itinerary.check_out)}</td>
                                                        <td className="imgdata">{data.booking_details[0].total_rooms}</td>
                                                        <td className="departuredata">{itinerary.room_type_name}</td>
                                                        <td className="imgdata">{data.booking_details[0].adult_count}</td>
                                                        <td className="imgdata">{data.booking_details[0].child_count}</td>
                                                    </tr>
                                                ))}

                                            </table>

                                            <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>

                                            <Box className='fdetailsHeading2 mb-1 mt-2'>
                                                <h4>Guest(s) details</h4>
                                            </Box>
                                            <table className="layoutdata">
                                               
                                                <tr className="headertltdata">
                                                    <td className="tltonwardtxt">Sr.No</td>
                                                    <td className="tltonwardtxt">Passenger(s) Name</td>
                                                    <td className="tltonwardtxt">Type</td>
                                                    <td className="tltonwardtxt">Age</td>
                                                </tr>
                                                {data.booking_details[0].customer_details.map((customer, c) => (
                                                    <tr className="headertltdataenties">
                                                        <td className="datatxt">{c + 1}</td>
                                                        <td className="datatxt caps">{customer.title + ' ' + customer.first_name + ' ' + customer.last_name}</td>
                                                        <td className="datatxt">{customer.pax_type}</td>
                                                        <td className="datatxt">{customer.age ? customer.age : 'NA'}</td>
                                                    </tr>
                                                ))}
                                            </table>

                                            <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>
                                            

                                            <table className="insidetablebox mt-2">
                                                <tr>
                                                    <td className="leftcol">
                                                        <table className="minitableleft">
                                                        
                                                            <Box className='fdetailsHeading2 mb-2 px-3 pt-2'>
                                                                <h4>Payment Details</h4>
                                                            </Box>
                                                            <tr>
                                                                <td className="minitabletxt">Base Fare</td>
                                                                <td className="minitabletxt"> &#x20B9; {addZeroes(data.fare.basefare)} </td>
                                                            </tr>

                                                            <tr>
                                                                <td className="minitabletxt">Taxes and Fees</td>
                                                                <td className="minitabletxt"> &#x20B9; {data.booking_details[0].offline_status == 1 ? addZeroes(data.fare.tax) : addZeroes(parseFloat(data.fare.tax) + parseFloat(data.fare.admin_markup) + parseFloat(data.fare.agent_markup) + parseFloat(data.booking_details[0].convinence_amount))} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="minitabletxt">Service Charge</td>
                                                                <td className="minitabletxt"> &#x20B9; {addZeroes(data.fare.service_charge)} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="minitabletxt">GST</td>
                                                                <td className="minitabletxt"> &#x20B9; {addZeroes(data.fare.gst)} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="minitabletxt">Discount</td>
                                                                <td className="minitabletxt"> &#x20B9; {addZeroes(data.booking_details[0].discount)} </td>
                                                            </tr>
                                                            <tr className="grandtotalmini">
                                                                <td className="minitabletxt">Grand Total</td>
                                                                <td className="minitabletxt"> &#x20B9; {data.booking_details[0].offline_status == 1 ? addZeroes(parseFloat(data.fare.basefare) + parseFloat(data.fare.tax) + parseFloat(data.fare.service_charge) + parseFloat(data.fare.gst)) : addZeroes(parseFloat(data.fare.basefare) + parseFloat(data.fare.admin_markup) + parseFloat(data.fare.agent_markup) + parseFloat(data.fare.tax) + parseFloat(data.fare.service_charge) + parseFloat(data.fare.gst) - parseFloat(data.booking_details[0].discount))} </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td>&nbsp;</td>
                                                    <td className="rightcol">
                                                        <table className="minitableright">
                                                            <tr className="minitableheaderright">
                                                                <td className="tdrgt contactDetails-td" colSpan="4">
                                                                    <Box className='fdetailsHeading2 mb-3 mt-1'>
                                                                        <h4>Contact Details</h4>
                                                                    </Box>
                                                                    <p className="pipediv">Email
                                                                        <span className='contactDetails'>{data.booking_details[0].customer_details[0].email}</span> 
                                                                    </p>
                                                                    <p className="pipediv">Phone Number 
                                                                        <span className='contactDetails'>{data.booking_details[0].customer_details[0].phone}</span>
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                            
                                                        </table>
                                                        
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>

                                            <table className="minitablehalfwidth mt-2">
                                                <tr className="minitableheaderright">
                                                    <td className="tdrgt" colSpan="4">
                                                    <Box className='fdetailsHeading2 mb-2 pt-2'>
                                                        <h4>Room Inclusions</h4>
                                                    </Box>
                                                    </td>
                                                </tr>
                                                {
                                                    data.booking_details[0].attributes && JSON.parse(data.booking_details[0].attributes)
                                                        ? JSON.parse(data.booking_details[0].attributes).Boarding_details.map(b => (
                                                        <tr className="minirgttxtheader">
                                                            <td className="minirgttxt">{b}</td>
                                                        </tr>

                                                        ))
                                                        : (
                                                        <tr>
                                                            <td className="minirgttxt">Room Only</td>
                                                        </tr>
                                                        )
                                                }
                                                <tr className="bagmini">
                                                    <td className="minirgttxt" colSpan="4">* Room inclusions are subject to change with hotels.</td>
                                                </tr>
                                            </table>
                                             <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>
{/*                                            
                                            <table className="rowspace">
                                                <tr>
                                                    <td className="details-td"><span>Customer Contant Details</span><span className="pipediv">Email: {data.booking_details[0].customer_details[0].email}</span><span>Contant Number: {data.booking_details[0].customer_details[0].phone}</span></td>
                                                </tr>
                                            </table> */}

                                            <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>
                                            <table className="hrtbl">
                                                <tr>
                                                    <td><hr></hr></td>
                                                </tr>
                                            </table>
                                            <table className="imp">
                                                <tr>
                                                    <td className="headingtltimppara">
                                                        <div className="tltplhead">Cancellation Policy</div>
                                                        {
                                                            data.booking_details[0].cancellation_policy instanceof Array
                                                              ? data.booking_details[0].cancellation_policy.map(c => (
                                                                <p>{c}</p>
                                                              ))
                                                              : data.booking_details[0].cancellation_policy
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="headingtltimppara">
                                                        <div className="tltplhead">Terms and Conditions</div>
                                                        <ul className="listvoucher">
                                                        <li>All Guests, including children and infants, must present valid identification at check-in.</li>
                                                        <li>Check-in begins 2 hours prior to the flight for seat assignment and closes 45 minutes prior to the scheduled departure.</li>
                                                        <li>Carriage and other services provided by the carrier are subject to conditions of carriage, which are hereby incorporated by reference. These conditions may be obtained from the issuing carrier.</li>
                                                        <li>In case of cancellations less than 6 hours before departure please cancel with the airlines directly. We are not responsible for any losses if the request is received less than 6 hours before departure.</li>
                                                        <li>Please contact airlines for Terminal Queries.</li>
                                                        <li>Free Baggage Allowance: Checked-in Baggage = 15kgs in Economy class.</li>
                                                        <li>Partial cancellations are not allowed for Round-trip Fares</li>
                                                        <li>Changes to the reservation will result in the above fee plus any difference in the fare between the original fare paid and the fare for the revised booking.</li>
                                                        <li>In case of cancellation of a booking, made by a Go channel partner, refund has to be collected from that respective Go Channel.</li>
                                                        <li>The No Show refund should be collected within 15 days from departure date.</li>
                                                        <li>If the basic fare is less than cancellation charges then only statutory taxes would be refunded.</li>
                                                        <li>We are not be responsible for any Flight delay/Cancellation from airline's end.</li>
                                                        <li>Kindly contact the airline at least 24 hrs before to reconfirm your flight detail giving reference of Airline PNR Number.</li>
                                                        <li>We are a travel agent and all reservations made through our website are as per the terms and conditions of the concerned airlines. All modifications,cancellations and refunds of the airline tickets shall be strictly in accordance with the policy of the concerned airlines and we disclaim all liability in connection thereof.</li>

                                                        </ul>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className="hrtbl">
                                                <tr>
                                                    <td><hr></hr></td>
                                                </tr>
                                            </table>
                                            {/* <table className="footervoucher">
                                                <tr>
                                                    <td className="tltfootervchr-tlt">{data.domainname}</td>
                                                </tr>
                                                <tr>
                                                    <td className="tltfootervchr-cnt">ContactNo : {data.phone}</td>
                                                </tr>
                                                <tr>
                                                    <td className="tltfootervchr-address"><p>{data.address}</p></td>
                                                </tr>
                                            </table> */}

                                            <Box className="footervoucher">
                                                <p className="tltfootervchr-tlt mb-0">{data.domainname}</p>
                                                <span className="tltfootervchr-cnt">Contact No: {data.phone}</span>
                                                <span className="tltfootervchr-cnt">Email ID: </span>
                                                
                                                {/* <tr>
                                                <td className="tltfootervchr-address"><span className="address-span">{domainAdd}</span></td>
                                                </tr> */}
                                            </Box>

                                            <table className="rowspace">
                                                <tr>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </table>
                                        </table>
                                    }
                                </Row>
                            </Box>
                        </Col>
                    </Row>
                )}

            </Container>
        </div>
  )
}

export default HotelVoucher
